export const AUTH_MOBILE_REQUEST = 'AUTH_MOBILE_REQUEST';
export const AUTH_MOBILE_SUCCESS = 'AUTH_MOBILE_SUCCESS';
export const AUTH_MOBILE_ERROR = 'AUTH_MOBILE_ERROR';
export const AUTH_OTP_REQUEST = 'AUTH_OTP_REQUEST';
export const AUTH_OTP_SUCCESS = 'AUTH_OTP_SUCCESS';
export const AUTH_OTP_ERROR = 'AUTH_OTP_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const ERROR_GEN_NETWORK = 'ERROR_GEN_NETWORK';
//# sourceMappingURL=actions.js.map